<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<style>
  html {
    overflow-x: hidden
  }
  .BMap_cpyCtrl {
    display: none;
  }
  /*去除百度logo*/
  .anchorBL {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue